<ng-container *transloco="let t">
    <mat-card
        class="altair-card technologies-card bg-white border-radius border-none d-block"
        [class.component-dark-theme]="themeService.isDark()"
    >
        @if (scan) {
        <mat-card-content>
            <h5 class="header-title mb-0">
                <span class="badge text-soft-info">{{ data.length }}</span>
                {{ t("discovered-technologies") }}
            </h5>
            <small class="text-warning float-end">
                &nbsp;
            </small>
            <br />
            @for (item of data; track item) {
            <span
                class="badge text-soft-info info"
                data-toggle="tooltip"
                data-placement="top"
                title="{{ item.count }} Subdomains use this technology."
            >
                {{ item.name }}
            </span>
            }
        </mat-card-content>
        }
    </mat-card>
</ng-container>
